import { Pipe, PipeTransform } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

/**
 * Developer Utility pipe (for debugging purposes), it prints controls of a given attribute on true.
 * By default prints all dirty controls
 *
 * @example
  Form dirty: {{ formEvent.form | controlFlag | async | json }}
  // prints all shallow controls with dirty on true

  Form invalid: {{ formEvent.form | controlFlag: 'invalid' | async | json }}
  // prints all shallow controls with invalid on true
 */
@Pipe({
  name: 'controlFlag',
  standalone: false,
})
export class PrintControlFlagsPipe implements PipeTransform {
  transform(targetControl: UntypedFormGroup, targetAttr = 'dirty'): Observable<any> {
    return new Observable(observer => {
      setTimeout(() => {
        const rootControls = Object.entries(targetControl.controls)
          .filter(([, control]) => control instanceof UntypedFormControl && control[targetAttr])
          .reduce((acc, [key, ctrl]) => ({ ...acc, [key]: ctrl[targetAttr] }), {});

        const nestedControls = Object.entries(targetControl.controls)
          .filter(
            ([, control]) =>
              (control instanceof UntypedFormArray || control instanceof UntypedFormGroup) && control[targetAttr]
          )
          .reduce((acc, [key, ctrl]) => ({ ...acc, [key]: ctrl[targetAttr] }), {});
        observer.next({ rootControls, nestedControls });
        observer.complete();
      }, 500);
    });
  }
}
